import { Link } from 'react-router-dom';
import { quickCategories } from '@/mocks/content';

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-5">
      {quickCategories.map((category) => (
        <Link
          key={category.type}
          to={`/category/${category.type}`}
          className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors p-5 md:p-6 flex items-center gap-4 cursor-pointer"
        >
          <span className="w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className={`${category.icon} text-2xl md:text-3xl`} />
          </span>
          <div className="min-w-0">
            <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
              {category.label}
            </h3>
            <p className="text-xs md:text-sm text-foreground-500 mt-1 truncate">{category.desc}</p>
            <p className="text-xs text-accent-600 mt-2 font-medium">
              共 {category.count} 部精选内容
            </p>
          </div>
          <i className="ri-arrow-right-s-line text-2xl text-foreground-300 ml-auto group-hover:text-primary-500 group-hover:translate-x-1 transition-all" />
        </Link>
      ))}
    </div>
  );
}